// import Vue from 'vue'
import router from '@/router'
// import axios from 'axios'

var src = '//0326.0f.cn' 
var newdata = 0;

export default{
	//图片的src
	imgSrc(){
		return src;
	},
	//app版本
	vesion(){
		return vesion;
	},
	location(){
		return '//0f.cn'
	},
	//提示
	msg(message, type){
		ElementUI.Message ({
		    message: message,
		    type: type
		});
	},
	//页面跳转
	href(url,data){
		router.push({ path: url, query: data})
	},
	//页面返回
	backHref(){
		router.go(-1)
	},
	//两秒后返回
	setBack(){
		setTimeout(()=>{
			router.go(-1)
		},2000)
	},
	//复制到剪贴板
	copy(text){
		console.log(text)
		uni.setClipboardData({
		    data: text,
		    success: function () {
				uni.showToast({
					title: '已复制成功',
					duration: 2000
				});
				// this.msg('')
		    }
		});
	},
	//检测是否登录
	// detect(){
	// 	return new Promise((resolve, reject) => {
	// 		axios.post('/api/user/info', {
			  
	// 		})
	// 		.then((res)=> {
	// 			if(res.code == 1){
	// 				localStorage.setItem('user', JSON.stringify(res.data))
	// 				resolve(true);
	// 			}
	// 		})
	// 	})
		
	// }
}


// WEBPACK FOOTER //
// ./src/common/api.js